import { createSlice } from "@reduxjs/toolkit";

import DEFAULT_THEME from "../data/theme.json";

const configSlice = createSlice({
  name: "config",
  initialState: {
    isLoading: false,
    theme: DEFAULT_THEME,
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setTheme(state, action) {
      state.theme = action.payload;
    },
  },
});

export const { setIsLoading, setTheme } = configSlice.actions;
export default configSlice.reducer;
